/*
 * Live platform facets (`GET /products/filters`) for the mobile nav and the
 * footer's platform links. Module-level so every consumer shares one request;
 * a failed request is retried by the next consumer. Owns no markup and no
 * counting rules — navData decides which facet belongs to which link.
 */
import { ref } from 'vue';
import { api } from '../../api/client';
import type { Facet } from '../../types/product';

const facets = ref<Facet[] | null>(null);
let pending: Promise<void> | null = null;

function load(): Promise<void> {
  pending ??= api
    .get<{ platforms: Facet[] }>('/products/filters')
    .then(({ data }) => { facets.value = data.platforms; })
    .catch(() => { pending = null; });
  return pending;
}

/** Facets, or null until the first response. */
export function usePlatformFacets() {
  void load();
  return facets;
}
